import { useRef, useState } from "react";
import { ScanLine, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Upload a photo / PDF / graphic and auto-extract fields via AI vision.
// kind: "partner" | "event" | "topic". onExtracted(fields) merges into the form.
export function DocScanButton({ kind, onExtracted, label = "Foto / PDF scannen" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("kind", kind);
    fd.append("file", file);
    try {
      const { data } = await api.post("/ai/extract", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const filled = Object.values(data).filter(Boolean).length;
      if (filled === 0) toast("Keine Felder erkannt – bitte manuell ergänzen.");
      else toast.success(`${filled} Feld(er) automatisch ausgelesen`);
      onExtracted(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Auslesen fehlgeschlagen");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="rounded-lg border border-dashed border-blue-300 bg-blue-50/60 p-3 flex items-center gap-3">
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,application/pdf"
        onChange={handle}
        className="hidden"
        data-testid={`scan-input-${kind}`}
      />
      <div className="flex-1">
        <div className="text-sm font-semibold text-blue-900 flex items-center gap-1.5">
          <ScanLine className="h-4 w-4" /> Schnell-Erfassung
        </div>
        <p className="text-[12px] text-blue-700/80 mt-0.5">Visitenkarte, Zettel, Flyer oder PDF – Felder werden automatisch ausgefüllt.</p>
      </div>
      <button
        type="button"
        data-testid={`scan-btn-${kind}`}
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        className="shrink-0 inline-flex items-center gap-2 text-sm font-medium px-3.5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-60"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ScanLine className="h-4 w-4" />}
        {busy ? "Liest aus…" : label}
      </button>
    </div>
  );
}
